import { render, staticRenderFns } from "./result-card.vue?vue&type=template&id=2b03eb06&scoped=true&"
import script from "./result-card.vue?vue&type=script&lang=ts&"
export * from "./result-card.vue?vue&type=script&lang=ts&"
import style0 from "./result-card.vue?vue&type=style&index=0&id=2b03eb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03eb06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle})
